import PlayAudioPage from './play-audio.page'

export default PlayAudioPage
